import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import type { FaqItem } from '@/lib/structured-data'

// Article FAQ accordion at the foot of the body. Mirrors the landing FaqSection
// card idiom (rounded card per item, single-open). Renders nothing when empty.
export function ArticleFaq({
  items,
  title,
}: {
  items?: FaqItem[]
  title: string
}) {
  if (!items?.length) return null
  return (
    <section className="mt-10 border-t border-border pt-10">
      <h2 className="font-serif text-2xl font-bold text-primary">{title}</h2>
      <Accordion type="single" collapsible className="mt-6 flex flex-col gap-3">
        {items.map((item, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            className="rounded-xl border border-primary/20 bg-card px-2 last:border-b"
          >
            <AccordionTrigger className="text-base font-semibold text-accent-foreground">
              {item.question}
            </AccordionTrigger>
            <AccordionContent className="px-4 pr-8 text-sm whitespace-pre-line text-accent-foreground/75">
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  )
}
